module.exports = __webpack_public_path__ + "img/f-5-1.40174847.png";